<template>
 <!-- Selected location detail -->
  <div v-if="vg_selectedStore">
    <h3
      :class="headingclass"
      v-text="vg_selectedStore.display_name ? vg_selectedStore.display_name : vg_selectedStore.name"
    ></h3>

    <p @click.prevent="getDirection(vg_selectedStore)"  class="is-size-14 is-flex justify-content-between is-underlined cursor-pointer hover-opacity-6 text-blue">
      {{ vg_selectedStore.address ? vg_selectedStore.address.formatted_address : '' }}
      <i class="fas fa-map-marker-alt" v-if="marker"></i>
    </p>

    <div>
      <!-- drop -->
        <div :class="'dropdown dropdown-open-close cart-location-timing ' + dropdown_class">
          <div class="dropdown-trigger">
            <button
              class="timing-button"
              :onclick="`javascript:document.querySelector('.${dropdown_class}').classList.toggle('is-active')`"
              :onblur="`javascript:document.querySelector('.${dropdown_class}').classList.remove('is-active')`"
              aria-haspopup="true"
              :aria-controls="dropdown_id"
            >
              <span
                :class="'availability-status has-text-weight-bold' + (vg_selectedStore.currently_open ? ' has-text-green' : ' has-text-red')"
              >{{ vg_selectedStore.currently_open ? 'OPEN' : 'CLOSED'}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span
                class="drop-down-spacer font-color is-size-14 cursor-pointer"
              >{{ vg_selectedStore.currently_open ? getTodaysOpenCloseSchedule() : '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' }} <i class="fas fa-caret-down"></i></span>
            </button>
          </div>
          <div class="dropdown-menu" :id="dropdown_id">
            <div class="ddown-content">
              <template v-for="(item, ind) in vg_selectedStore.hours_of_operation">
                <a
                  :class="'is-flex justify-content-between dropdown-item ' + (item.day == todayDayNumber() ? 'active':'')"
                  :key="ind"
                >
                  <span
                    class="day has-text-black"
                  >{{item.day_name}} {{ item.day == todayDayNumber() ? '(today)':''}}</span>
                  <span v-if="!item.is_open" class="timing has-text-black">Closed</span>
                  <span v-else class="timing has-text-black">{{getOpenCloseTime(item)}}</span>
                </a>
              </template>
            </div>
          </div>
        </div>
      <!-- drop --> 
    </div>
  </div>
  <!-- Selected location detail ends -->
</template>


<script>
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
  name: 'SelectedLocationDisplay',
  data() {
    return {
      dropdown_id: 'id_' + Math.random().toString(36).substr(2, 5),
      dropdown_class: 'class_' + Math.random().toString(36).substr(2, 5),
    };
  },
  props: ['marker', 'headingclass'],
  computed: {
    ...mapGetters({
      vg_selectedStore: "location/selected",
    }),
  },

  async mounted() {
   
  },

  methods: {
    /**
     * Open Close schedule
     */
    getTodaysOpenCloseSchedule() {
      let todaysSchedule = _.find(this.vg_selectedStore.hours_of_operation, function (o) { return o.day == new Date().getDay(); });
      if (todaysSchedule != undefined) {
        return this.getOpenCloseTime(todaysSchedule);
      }
      return '';
    },

     /**
     * Concert time to new readable format 
     */
    dropDownDateTimeReadableFormat(dropDownTime) {
      let a = moment(dropDownTime, "YYYY-MM-DD hh:mm a");
      return a.format('MMMM DD, YYYY @ h:mm A');
    },

    /**
     * Today in number format
     */
    todayDayNumber() {
      return new Date().getDay();
    },
    
    // Get opening and closing time for all the days of week
    getOpenCloseTime(item) {
      return `${moment(item.open_time, "HH:mm:ss").format("hh:mm a")} - ${moment(item.close_time, "HH:mm:ss").format("hh:mm a")}`;
    },

    /**
     * 
     * Open in new tab, location google map
     */
    getDirection(storeDetail) {
      // Open external google map
      if(!_.isEmpty(storeDetail) && !storeDetail.address) {
        return '';
      } else {
        window.open(`https://www.google.com/maps/place/${storeDetail.address.formatted_address}/@${storeDetail.address.latitude},${storeDetail.address.longitude},17.55z'`, '_blank');
      }
    },

  },
};
</script>

